// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f455e2a7","453":"cd7affc2","455":"74666b59","977":"60cc7b00"}[chunkId] + ".chunk.js";
};